import { makeObservable, observable, action } from 'mobx'
import axios from 'axios'
import { BaseStore } from './BaseStore'
import type { LineSetting } from '@/types'

export class SettingStore extends BaseStore {
  lineSetting: LineSetting | null = null

  constructor() {
    super()
    makeObservable(this, {
      lineSetting: observable,
      getLineSetting: action,
      updateLineSetting: action
    })
  }

  async getLineSetting(tenantId: string) {
    const result = await this.handleApiCall(async () => {
      const response = await axios.get<LineSetting>(
        this.apiPath(`v1/tenants/${tenantId}/settings/line`),
        { headers: this.generateFetchHeader() }
      )
      return response.data
    })

    if (result) {
      this.lineSetting = result
      return true
    }
    return false
  }

  async updateLineSetting(tenantId: string, data: { channel_id: string; channel_secret: string; long_term_token: string }) {
    const result = await this.handleApiCall(async () => {
      await axios.put(
        this.apiPath(`v1/tenants/${tenantId}/settings/line`),
        data,
        { headers: this.generateFetchHeader() }
      )
      return true
    })

    if (result) {
      // 更新されたLINE設定を再取得
      await this.getLineSetting(tenantId)
      this.tryShowToast('LINE設定を更新しました', 'success')
      return true
    }

    this.tryShowToast('LINE設定の更新に失敗しました', 'error')
    return false
  }
}